<div class="row">
  <div class="col-7 mb-3">
    <h2 class="title-list">List of Customers</h2>
  </div>

  <div class="col-2 text-end" *ngIf="!readOnly">
    <button class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#modalTransfer"
      [disabled]="!isAnyCheckboxSelectedPartnerCustomer">
      Transfer Customers
    </button>
  </div>

  <div class="col-1 text-end">
    <button class="btn btn-secondary" (click)="exportToExcelListPartnerCustomers()">
      <i class="bi bi-file-earmark-excel"></i>
    </button>
  </div>

  <div class="col-2 text-end" *ngIf="!readOnly">
    <button class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#modalArchive">
      Assign Customers
    </button>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <div class="input-group mb-3">
      <span class="input-group-text" id="basic-addon1">
        <i class="bi bi-search"></i>
      </span>
      <input type="text" class="form-control input-label" placeholder="Search" [(ngModel)]="textoBusqueda"
        (input)="onSearchChange()" />
    </div>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <div class="table-responsive rounded-5">
      <table class="table table-striped mb-0">
        <caption class="d-none">
          List of partners and their details
        </caption>
        <thead class="head-table">
          <tr>
            <th class="px-4 py-3 align-middle" *ngIf="!readOnly" >
              <input type="checkbox" (change)="selectAllCheckboxesPartnerCustomer($event)" />
            </th>
            <th class="px-4 py-3 align-middle">Customer Account</th>
            <th class="px-4 py-3 align-middle">Name</th>
            <th class="px-4 py-3 align-middle">Email</th>
            <th class="px-4 py-3 align-middle">Contact Number</th>
            <th class="px-4 py-3 align-middle"># Plans</th>
            <th class="px-4 py-3 align-middle">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="
              let partner of partners
                | search : textoBusqueda : camposBusqueda
                | slice : (currentPage - 1) * 10 : currentPage * 10
            ">
            <td class="px-4 py-3 align-middle" *ngIf="!readOnly">
              <input type="checkbox" [(ngModel)]="partner.checked" (change)="checkboxChangedPartnerCustomer()" />
            </td>
            <td class="px-4 py-3 align-middle" [style.opacity]="partner.userStatus === 0 ? '0.6' : '1'"
              title="{{ partner.customerAccount }}">
              {{ partner.customerAccount }}
            </td>
            <td class="px-4 py-3 align-middle" [style.opacity]="partner.userStatus === 0 ? '0.6' : '1'"
                title="{{ partner.userNames }}">
                @if (permissionsService.customers.readPermission) {
                <a href="customers/customer-account/{{ partner.customerAccount }}">{{ partner.userNames }}</a>
                } @else {
                {{ partner.customerAccount }}
                }
            </td>
            <td class="px-4 py-3 align-middle" [style.opacity]="partner.userStatus === 0 ? '0.6' : '1'"
              title="{{ partner.userMail }}">
              {{ partner.userMail }}
            </td>
            <td class="px-4 py-3 align-middle" [style.opacity]="partner.userStatus === 0 ? '0.6' : '1'"
              title="{{ partner.userPhone }}">
              {{ partner.userPhone }}
            </td>
            <td class="px-4 py-3 align-middle" [style.opacity]="partner.userStatus === 0 ? '0.6' : '1'"
              title="{{ partner.numberPlans }}">
              {{ partner.numberPlans }}
            </td>
            <td class="px-4 py-3 align-middle">
              <div *ngIf="partner.userStatus === 0 || partner.userStatus === 1" class="form-check form-switch">
                <input class="form-check-input" type="checkbox" [(ngModel)]="partner.userStatus" [disabled]="readOnly"
                  id="flexSwitchCheckDefault" [checked]="partner.userStatus === 1" (change)="
                    toggleStatus($event, partner); setSelectedPartner(partner)
                  " data-bs-toggle="modal" data-bs-target="#modalSwitch" disabled />
              </div>
              <div *ngIf="partner.userStatus === 2">
                <span class="archived">Archived</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="row d-flex align-items-center justify-content-between">
  <div class="col-2">
    <label>
      Showing {{ (currentPage - 1) * recordsPerPage + 1 }} to {{ currentPage * recordsPerPage < partners.length ?
        currentPage * recordsPerPage : partners.length }} out of {{ partners.length }} entries </label>
  </div>
  <div class="col-7">
    <div class="col-12 pagination text-left">
      <nav aria-label="Page navigation example">
        <ul class="pagination">
          <li class="page-item" [class.disabled]="currentPage === 1">
            <a class="page-link" href="javascript:void(0)" tabindex="-1" aria-disabled="true" (click)="previousPage()">
              <i class="bi bi-chevron-left"></i>
            </a>
          </li>
          <ng-container *ngFor="let page of pages">
            <li class="page-item" [class.active]="page === currentPage">
              <a class="page-link" href="javascript:void(0)" (click)="changePage(page)">{{ page }}</a>
            </li>
          </ng-container>
          <li class="page-item" [class.disabled]="currentPage === totalPages">
            <a class="page-link" href="javascript:void(0)" (click)="nextPage()">
              <i class="bi bi-chevron-right"></i>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</div>

<!-- Modal Assign Customer -->
<div class="modal fade" id="modalArchive" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title modal-titles" id="exampleModalLabel" style="font-weight: bold;">Assign Customers</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="assignCustomers(false)"></button>
      </div>
      <div class="modal-body">
        <div class="mb-4">
          Please select the customers you want to assign to this partner. When you’re done, click the Assign Customers
          button.
        </div>
        <div class="row">
          <div class="col-12 mb-3">
            <h2 class="title-list">List of Customers</h2>
          </div>
        </div>
        <div class="col-12">
          <div class="input-group mb-3">
            <span class="input-group-text" id="basic-addon1">
              <i class="bi bi-search"></i>
            </span>
            <input type="text" class="form-control input-label" placeholder="Search" [(ngModel)]="textoBusquedaAssignCustomer"
              (input)="onsereachChangeAvailables()" />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="table-responsive rounded-5">
              <table class="table table-striped mb-0">
                <caption class="d-none">
                  List of partners and their details
                </caption>
                <thead class="head-table">
                  <tr>
                    <th class="px-4 py-3 align-middle">
                      <input type="checkbox" (change)="selectAllCheckboxes($event)" />
                    </th>
                    <th class="px-4 py-3 align-middle">Customer Account</th>
                    <th class="px-4 py-3 align-middle">Name</th>
                    <th class="px-4 py-3 align-middle">Email</th>
                    <th class="px-4 py-3 align-middle">Contact Number</th>
                    <th class="px-4 py-3 align-middle"># Plans</th>
                    <th class="px-4 py-3 align-middle">Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="
                        let partner of customersAvailables
                          | searchModal : textoBusquedaAssignCustomer : camposBusqueda
                          | slice : (currentPageAvailables - 1) * 10 : currentPageAvailables * 10
                      ">
                    <td class="px-4 py-3 align-middle">
                      <input type="checkbox" [(ngModel)]="partner.checked" (change)="checkboxChanged()" />
                    </td>
                    <td class="px-4 py-3 align-middle" [style.opacity]="partner.userStatus === 0 ? '0.6' : '1'">
                      {{ partner.customerAccount }}
                    </td>
                    <td class="px-4 py-3 align-middle" [style.opacity]="partner.userStatus === 0 ? '0.6' : '1'">
                      {{ partner.userNames }}
                    </td>
                    <td class="px-4 py-3 align-middle" [style.opacity]="partner.userStatus === 0 ? '0.6' : '1'">
                      {{ partner.userMail }}
                    </td>
                    <td class="px-4 py-3 align-middle" [style.opacity]="partner.userStatus === 0 ? '0.6' : '1'">
                      {{ partner.userPhone }}
                    </td>
                    <td class="px-4 py-3 align-middle" [style.opacity]="partner.userStatus === 0 ? '0.6' : '1'">
                      {{ partner.numberPlans }}
                    </td>
                    <td class="px-4 py-3 align-middle">
                      <div *ngIf="partner.userStatus === 0 || partner.userStatus === 1" class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" [(ngModel)]="partner.userStatus"
                          id="flexSwitchCheckDefault" [checked]="partner.userStatus === 1" (change)="
                              toggleStatusAvailables($event, partner); setSelectedPartner(partner)
                            " data-bs-toggle="modal" data-bs-target="#modalSwitch" disabled />
                      </div>
                      <div *ngIf="partner.userStatus === 2">
                        <span class="archived">Archived</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="row d-flex align-items-center justify-content-between">
          <div class="col-3">
            <label>
              Showing {{ (currentPageAvailables - 1) * recordsPerPage + 1 }} to {{ currentPageAvailables *
              recordsPerPage < customersAvailables.length ? currentPageAvailables * recordsPerPage :
                customersAvailables.length }} out of {{ customersAvailables.length }} entries </label>
          </div>
          <div class="col-7">
            <div class="col-12 pagination text-left">
              <nav aria-label="Page navigation example">
                <ul class="pagination">
                  <li class="page-item" [class.disabled]="currentPageAvailables === 1">
                    <a class="page-link" href="javascript:void(0)" tabindex="-1" aria-disabled="true"
                      (click)="previousPageAvailables()">
                      <i class="bi bi-chevron-left"></i>
                    </a>
                  </li>
                  <ng-container *ngFor="let pageAv of pageAvailables">
                    <li class="page-item" [class.active]="pageAv === currentPageAvailables">
                      <a class="page-link" href="javascript:void(0)" (click)="changePageAvailables(pageAv)">{{ pageAv
                        }}</a>
                    </li>
                  </ng-container>
                  <li class="page-item" [class.disabled]="currentPageAvailables === totalPagesAvailables">
                    <a class="page-link" href="javascript:void(0)" (click)="nextPageAvailables()">
                      <i class="bi bi-chevron-right"></i>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="assignCustomers(false)">
          Cancel
        </button>
        <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="assignCustomers(true)"
          [disabled]="!isAnyCheckboxSelected">
          Assign Customers
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Fin Modal Assign Customer -->

<!-- Modal Transfer Customer -->
<div class="modal fade" id="modalTransfer" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title modal-titles" id="exampleModalLabel" style="font-weight: bold;">Transfer Customers</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="transferCustomers(false)"></button>
      </div>
      <div class="modal-body">
        <div class="mb-4">
          Please select the new Partner:
        </div>
        <div class="row">
          <div class="col-12 mb-3">
            <h2 class="title-list">List of Partners</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="input-group mb-3">
              <span class="input-group-text" id="basic-addon1">
                <i class="bi bi-search"></i>
              </span>
              <input type="text" class="form-control input-label" placeholder="Search"
                [(ngModel)]="textoBusquedaTransferCustomer" (input)="updatePaginationPartnerAvailables()" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="table-responsive rounded-5">
              <table class="table table-striped mb-0">
                <caption class="d-none">
                  List of partners and their details
                </caption>
                <thead class="head-table">
                  <tr>
                    <th class="px-4 py-3 align-middle">

                    </th>
                    <th class="px-4 py-3 align-middle">Partner ID</th>
                    <th class="px-4 py-3 align-middle">Name</th>
                    <th class="px-4 py-3 align-middle">Email</th>
                    <th class="px-4 py-3 align-middle">Contact Number</th>
                    <th class="px-4 py-3 align-middle">Total Staff</th>
                    <th class="px-4 py-3 align-middle">Total Customers</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="
                        let partner of partnersAvailables
                          | searchModal : textoBusquedaTransferCustomer : camposBusquedaAvailables
                          | slice : (currentPage - 1) * 10 : currentPage * 10
                      ">
                    <td class="px-4 py-3 align-middle">
                      <input type="checkbox" [(ngModel)]="partner.checked"
                        (change)="checkboxChangedTransfer(partner)" />
                    </td>
                    <td class="px-4 py-3 align-middle" [style.opacity]="1">
                      {{ partner.idPartner }}
                    </td>
                    <td class="px-4 py-3 align-middle">
                      {{ partner.namePartner }}
                    </td>
                    <td class="px-4 py-3 align-middle">
                      {{ partner.mailPartner }}
                    </td>
                    <td class="px-4 py-3 align-middle">
                      {{ partner.phone }}
                    </td>
                    <td class="px-4 py-3 align-middle">
                      {{ partner.totalStaff }}
                    </td>
                    <td class="px-4 py-3 align-middle">
                      {{ partner.totalCustomers }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="row d-flex align-items-center justify-content-between">
          <div class="col-3">
            <label>
              Showing {{ (currentPage - 1) * recordsPerPage + 1 }} to {{ currentPage * recordsPerPage <
                partnersAvailables.length ? currentPage * recordsPerPage : partnersAvailables.length }} out of {{
                partnersAvailables.length }} entries </label>
          </div>
          <div class="col-7">
            <div class="col-12 pagination text-left">
              <nav aria-label="Page navigation example">
                <ul class="pagination">
                  <li class="page-item" [class.disabled]="currentPagePartnerAvailables === 1">
                    <a class="page-link" href="javascript:void(0)" tabindex="-1" aria-disabled="true"
                      (click)="previousPagePartnerAvailables()">
                      <i class="bi bi-chevron-left"></i>
                    </a>
                  </li>
                  <ng-container *ngFor="let page of pagePartnerAvailables">
                    <li class="page-item" [class.active]="page === currentPagePartnerAvailables">
                      <a class="page-link" href="javascript:void(0)" (click)="changePagePartnerAvailables(page)">{{ page
                        }}</a>
                    </li>
                  </ng-container>
                  <li class="page-item" [class.disabled]="currentPageAvailables === totalPagesPartnerAvailables">
                    <a class="page-link" href="javascript:void(0)" (click)="nextPageAvailables()">
                      <i class="bi bi-chevron-right"></i>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="transferCustomers(false)">
          Cancel
        </button>
        <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="transferCustomers(true)"
          [disabled]="!isAnyCheckboxSelectedTransfer">
          Transfer Customers
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Fin Modal Transfer Customer -->